import { RESET_CART, generateBFFUrl } from '@/configs/apiEndPoints';
import { ASSET_ID_QUERY_PARAM } from '@/configs/serviceConstants';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';

export const resetCart = async (assetId: string, serverCookie?: any): Promise<{}> => {
  const cartData = await axiosInstance
    .get(generateBFFUrl(RESET_CART), {
      headers: generateHttpHeaders(serverCookie),
      params: {
        [ASSET_ID_QUERY_PARAM]: assetId,
      },
    })
    .then(({ data }) => {
      return data;
    })
    .catch((err: any) => {
      const { response } = err;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return cartData;
};
